module.exports = __webpack_public_path__ + "static/media/sakura_activecf9476f8152e4468168577bec8818fc7.webp";